import { Component, ViewChild } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NavParams, IonDatetime, ModalController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DateService } from '@shared/services';

@Component({
    'selector': 'app-calendarModal',
    'templateUrl': './calendarModal.page.html',
    'styleUrls': ['./calendarModal.page.scss'],
    'standalone': true,
    imports: [IonicModule, CommonModule, FormsModule]
})
export class CalendarModalPage implements OnInit {
    @ViewChild('myDatetime') public myDateTime!: IonDatetime;
    private dateService: DateService = new DateService();
    public title: string;
    public viewTitle = '';
    public dateRangeStartISO: string;
    public dateRangeEndISO: string;
    public selectedDateISO: string;
    public todayISO: string;
    public presentation = 'date';

    constructor(public modalController: ModalController, private navParams: NavParams) {
    }

    public ngOnInit(): void {
        let dateTemp;

        // Get the values that were passed in.
        this.title = this.navParams.get('title');
        // this.dateRangeStart = this.navParams.get('dateRangeStart');
        // this.dateRangeStartISO = this.dateService.formatTimestamp(this.dateRangeStart, 'iso');
        dateTemp = this.navParams.get('dateRangeStart');
        this.dateRangeStartISO = this.dateService.formatTimestamp(dateTemp, 'iso');

        dateTemp = this.navParams.get('dateRangeEnd');
        this.dateRangeEndISO = this.dateService.formatTimestamp(dateTemp, 'iso');

        // this.selectedDate = this.navParams.get('selectedDate');
        // this.selectedDateISO = this.dateService.formatTimestamp(this.selectedDate, 'iso');

        dateTemp = this.navParams.get('selectedDate');
        this.selectedDateISO = this.dateService.formatTimestamp(dateTemp, 'iso');

        this.todayISO = this.dateService.formatTimestamp('now', 'iso');
    }

    // ionViewWillEnter(): void {
    // }

    // public next() {
    //     this.myCalendar.slideNext();
    //     this.myCalendar.update();
    // }

    // public back() {
    //     this.myCalendar.slidePrev();
    //     this.myCalendar.update();
    // }

    public getMaximumDate(): string {
        return this.dateRangeEndISO;
    }

    public getMinimumDateISO(): string {
        return this.dateRangeStartISO;
    }

    public getMaximumDateISO(): string {
        return this.dateRangeEndISO;
    }

    public getSelectedDateISO(): string {
        return this.selectedDateISO;
    }

    public async onSignupDateClick(): Promise<void> {
        this.selectedDateISO = this.dateRangeStartISO;
        await this.myDateTime.reset(this.dateRangeStartISO);
    }

    public async onTodayClick(): Promise<void> {
        this.selectedDateISO = this.todayISO;
        await this.myDateTime.reset(this.todayISO);
    }

    public onChange(event: any): void {
        this.selectedDateISO = event.detail.value;
    }

    // The caller of this method will access this response object with code that looks like this:
    // const response: any = await this.openCalendarModal(
    //      this.dateRangeStart, this.dateRangeEnd, this.selectedStartDate, 'Select Starting Date');
    // if (response.data.okay) {
    //      this.selectedStartDate = this.dateService.toTimestamp(response.data.selectedItems[0]);
    // }
    public async onOkayClick(): Promise<void> {
        const response: any = { 'okay': true, 'selectedItems': [this.selectedDateISO] };
        await this.modalController.dismiss(response);
    }

    public async onCancelClick(): Promise<void> {
        const response: any = { 'okay': false, 'selectedItems': null };
        await this.modalController.dismiss(response);
    }
}
